import request from "../../utils/request";

export function parseSql(sql) {
  return request({
    url: '/report/design/parseSql',
    method: 'post',
    data: {sql: sql}
  })
}


export function saveOrUpdate(data) {
  return request({
    url: '/report/design/saveOrUpdate',
    method: 'post',
    data: data
  })
}

export function getById(id) {
  return request({
    url: '/report/design/get',
    method: 'post',
    data: { id: id }
  })
}
